import { Box, Card, Stack, Text } from 'braid-design-system';
import React from 'react';

import { Language, type LanguageProps } from './Language';

interface LanguagesProps {
  languages: LanguageProps[];
  displayVariant?: 'card';
}

export const Languages = (props: LanguagesProps) => {
  const { languages, displayVariant } = props;
  const displayAsCard = displayVariant === 'card';

  return (
    <Stack component="ul" space={displayAsCard ? 'small' : 'medium'}>
      {languages.map((language) => (
        <Box component="li" key={`language-${language.name.text}`}>
          {displayAsCard ? (
            <Card>
              <Language {...language} />
            </Card>
          ) : (
            <Text>{language.name.text}</Text>
          )}
        </Box>
      ))}
    </Stack>
  );
};
